var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiRrPlug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 4.66667H11.3337V0.666667C11.3337 0.298667 11.0357 0 10.667 0C10.2983 0 10.0003 0.298667 10.0003 0.666667V4.66667H6.00033V0.666667C6.00033 0.298667 5.70233 0 5.33366 0C4.96499 0 4.66699 0.298667 4.66699 0.666667V4.66667H1.33366C0.964992 4.66667 0.666992 4.96533 0.666992 5.33333C0.666992 5.70133 0.964992 6 1.33366 6H2.00033V8C2.00033 11.0827 4.33766 13.63 7.33366 13.9627V15.3333C7.33366 15.7013 7.63166 16 8.00033 16C8.36899 16 8.66699 15.7013 8.66699 15.3333V13.9627C11.663 13.63 14.0003 11.0827 14.0003 8V6H14.667C15.0357 6 15.3337 5.70133 15.3337 5.33333C15.3337 4.96533 15.0357 4.66667 14.667 4.66667ZM12.667 8C12.667 10.5733 10.573 12.6667 8.00033 12.6667C5.42766 12.6667 3.33366 10.5733 3.33366 8V6H12.667V8Z",
    fill: "#2F3037"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrPlug);
export default __webpack_public_path__ + "static/media/fi-rr-plug.88c6fb04ae383ede901e6370b911efeb.svg";
export { ForwardRef as ReactComponent };